import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=7a56fe6e&scoped=true"
import script from "./ImageModal.vue?vue&type=script&lang=js"
export * from "./ImageModal.vue?vue&type=script&lang=js"
import style0 from "./ImageModal.vue?vue&type=style&index=0&id=7a56fe6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a56fe6e",
  null
  
)

export default component.exports